import { Icon } from '@trlogic/ui-pack';
import React, { Component } from 'react';
import CustomCheckBox from './CustomCheckBox';
import FormicaLabel from './FormicaLabel';

class CustomMultiSelectBox extends Component<Props, State> {
  public state: State = new State();

  private selectBoxRef = React.createRef<HTMLDivElement>();
  private componentRef: React.RefObject<HTMLButtonElement> = React.createRef();

  render() {
    const { label } = this.props;
    const { search, selectAll, visible } = this.state;
    return (
      <button
        ref={this.componentRef}
        onClick={() => this.setState({ visible: !visible })}
        className={'flex flex-col gap-y-1.5 items-center w-full group relative'}
      >
        <FormicaLabel className={'self-start'} label={label} />
        <div className={'flex items-center w-full h-auto relative'}>
          <input
            value={search}
            onChange={(event) => this.setState({ search: event.target.value })}
            className={
              'h-[34px] text-f-black-2 border-[1px] border-[#EAECF0] text-xs placeholder-[11px] w-full rounded-[4px] indent-3 outline-none hover:border-[#728EFF] focus:formica-shadow transition-all focus:border-[#728EFF]'
            }
            id={'search-input'}
            placeholder={this.getPlaceholder()}
          />
          <Icon
            icon={'arrow-down'}
            className={
              'pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 right-3 text-f-black-4 group-hover:text-f-purple group-focus-within:text-f-purple '
            }
            size={20}
          />
        </div>
        <div
          onClick={(e) => e.stopPropagation()}
          ref={this.selectBoxRef}
          className={`flex flex-col w-full absolute top-[74px] z-50  bg-white shadow-sm ease-out transition-all  overflow-y-scroll  border-[1px] border-[##EAECF0] rounded-[4px] ${visible ? 'h-[300px] max-h-[340px] opacity-100' : 'h-0 max-h-0 opacity-0'}`}
        >
          <div className={'flex gap-x-3 px-3 h-[40px] min-h-[40px] items-center'}>
            <CustomCheckBox checked={selectAll} onChangeChecked={this.onChangeSelectAll} />
            <label className={'text-semibold'}>Select All</label>
          </div>
          <ul className={'flex flex-col'}>
            {search != ''
              ? this.state.dummyOptions
                  .filter((option) => option.label.toLowerCase().includes(search.toLowerCase()))
                  .map((option, index) => {
                    return (
                      <li
                        key={index}
                        className={`${option.isSelected ? 'bg-[#458EF7]/8' : 'bg-white'} hover:bg-main-gray flex shrink-0 items-center gap-x-2 h-[40px] w-full px-3 py-2`}
                      >
                        <CustomCheckBox
                          checked={option.isSelected}
                          onChangeChecked={(checked) => {
                            option.isSelected = checked;
                            this.setState({ dummyOptions: this.state.dummyOptions }, () => this.onClickOption(checked, option));
                          }}
                        />
                        <p className={'flex w-full text-f-black-2 truncate'}>{option.label}</p>
                      </li>
                    );
                  })
              : this.state.dummyOptions.map((option, index) => {
                  return (
                    <li
                      key={index}
                      className={`${option.isSelected ? 'bg-[#458EF7]/10' : 'bg-white'} hover:bg-main-gray flex items-center gap-x-2 h-[40px] w-full px-3 py-2`}
                    >
                      <CustomCheckBox
                        checked={option.isSelected}
                        onChangeChecked={(checked) => {
                          option.isSelected = checked;
                          this.setState({ dummyOptions: this.state.dummyOptions }, () => this.onClickOption(checked, option));
                        }}
                      />
                      <p className={'text-f-black-2'}>{option.label}</p>
                    </li>
                  );
                })}
          </ul>
        </div>
      </button>
    );
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
    //document.addEventListener('mousedown', (e) => this.handleClickOutside(e));
    const { selectedItems, options } = this.props;
    const stateOptions: MultiSelectBoxStateItem[] = options.map((item) => {
      if (selectedItems?.find((selectedItem) => selectedItem == item.value)) {
        return { ...item, isSelected: true };
      }
      return { ...item, isSelected: false };
    });
    this.setState({ dummyOptions: stateOptions });
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const { selectedItems, options } = this.props;
    if (prevProps.selectedItems != selectedItems) {
      const stateOptions: MultiSelectBoxStateItem[] = options.map((item) => {
        if (selectedItems?.find((selectedItem) => selectedItem == item.value)) {
          return { ...item, isSelected: true };
        }
        return { ...item, isSelected: false };
      });
      this.setState({ dummyOptions: stateOptions });
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    //document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: any) => {
    if (this.componentRef.current && !this.componentRef.current.contains(event.target)) {
      this.setState({ visible: false });
    }
  };
  private onClickOption = (checked: boolean, option: MultiSelectBoxStateItem) => {
    const { onChangeSelectedItems } = this.props;
    const { dummyOptions } = this.state;
    const selectedOptions = dummyOptions.filter((option) => option.isSelected);
    const isAllSelected = this.checkAllSelected();
    this.setState({ selectAll: isAllSelected });
    onChangeSelectedItems(selectedOptions.map((item) => item.value));
  };

  private checkAllSelected = (): boolean => {
    const { dummyOptions } = this.state;
    let selectedItemsCount: number = 0;
    dummyOptions.forEach((option) => {
      if (option.isSelected) {
        selectedItemsCount++;
      }
    });
    return selectedItemsCount == dummyOptions.length;
  };

  private getPlaceholder = (): string | undefined => {
    const { dummyOptions } = this.state;
    let selectedItemsCount: number = 0;
    dummyOptions.forEach((option) => {
      if (option.isSelected) {
        selectedItemsCount++;
      }
    });
    return `${selectedItemsCount} selected`;
  };

  private onChangeSelectAll = (checked: boolean): void => {
    const { dummyOptions } = this.state;
    const { onChangeSelectedItems, selectedItems } = this.props;
    if (checked) {
      dummyOptions.forEach((option) => {
        option.isSelected = true;
      });
      selectedItems.splice(0, selectedItems.length);
      dummyOptions.forEach((option) => {
        selectedItems.push(option.value);
        onChangeSelectedItems(selectedItems);
      });
    } else {
      dummyOptions.forEach((option) => {
        option.isSelected = false;
      });
      selectedItems.splice(0, selectedItems.length);
      onChangeSelectedItems(selectedItems);
    }
    this.setState({ selectAll: checked, dummyOptions });
  };
}

interface Props {
  label: string;
  options: MultiSelectBoxItem[];
  selectedItems: string[];
  onChangeSelectedItems: (selectedItems: any[]) => void;
}

export interface MultiSelectBoxItem {
  label: string;
  value: string;
}

interface MultiSelectBoxStateItem extends MultiSelectBoxItem {
  isSelected: boolean;
}

class State {
  search: string = '';
  selectAll: boolean = false;
  dummyOptions: MultiSelectBoxStateItem[] = [];
  visible: boolean = false;
}

export default CustomMultiSelectBox;
